import { Molecule, wrap, Wrapper } from 'AppReact'
import styled from 'styled-components'
import { GrayTextSm, SecondaryTextSm } from 'atoms';
import { FlexBoxWrapper, FlexCenterWrapper, Mr2 } from "wrappers";
import { TextButton, } from 'molecules';

const template = styled.div``

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      wrapper: FlexCenterWrapper,
      name: "Wrapper",
      atoms: [
        {
          component: wrap(SecondaryTextSm, Mr2),
          displayState: () => ({ color: window?.settings?.secondary_color ?? '#04333b' }),
          name: 'Label',
          renderIf: ({ label }) => !!label,
          displayValue: ({ label }) => `${label}: `,
        },
        {
          component: wrap(TextButton, FlexBoxWrapper),
          name: 'Button',
          renderIf: ({ }) => true,
          bindings: ({ value }) => ({ title: value ?? '', })
        },
      ]
    }
  ]
})
